import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
`

export const VideoContainer = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`

export const BlendDiv = styled.div`
  mix-blend-mode: multiply;
  background-color: #003a72;
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 1;
  top: 0;
`

export const ViptechLogoDiv = styled.div`
  display: flex;
  position: absolute;
  bottom: 2em;
  right: 2em;
`

export const LoginBox = styled.div`
  width: 532px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 20px;
  padding: 48px 56px;
  backdrop-filter: blur(16px);
  border-radius: 16px;
  box-shadow: ${({theme}) => `0px 4px 24px 0px ${theme.login.boxShadowColor}`};
  background: ${({theme}) => theme.login.backdropColor};

  @media (max-width: 500px) {
    padding: 20px 32px;
    gap: 20px;
    width: auto;
    min-width: 300px;
  }
`

export const TopDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-bottom: 16px;
`

export const Logo = styled.img`
  width: ${({theme}) => theme.login.logoWidth};
`

export const MessageSpan = styled.span`
  font-style: normal;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  text-align: center;
  font-size: 24px;
  line-height: 38px;
  color: ${(props) => props.color};
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.5em;
`

export const Input = styled.input`
  font-size: 16px;
  color: #eaecf0;
  width: 100%;
  background-color: #344054;
  height: 52px;
  border-radius: 12px;
  border: none;
  text-indent: 4%;
  outline: 0;
  :focus {
    outline: none;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:hover {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #eaecf0 !important;
    caret-color: #eaecf0;
  }
`

export const ButtonDiv = styled.div`
  width: 100%;
  margin-top: 40px;
`

export const Button = styled.button`
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #004677;
  color: white;
  font-size: 19px;
  background-color: #009eff;
  width: 100%;
  height: 2em;
  transition: 0.4s;
  font-weight: bold;
  :hover {
    background-color: #00639f;
  }
  :disabled {
    opacity: 0.4;
    cursor: default;
    :hover {
      background-color: #009eff;
    }
  }
`

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 500px) {
    font-size: 14px;
  }
`

export const ContainerOptions = styled.div`
  color: white;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  @media (max-width: 500px) {
    font-size: 10px;
    margin-top: 10px;
    gap: 8px;
  }
`

export const LinkText = styled.span`
  color: #009eff;
  font-size: 14px;
`

export const ContainerSSO = styled.div<{marginTop?: string}>`
  margin-top: ${(props) => props.marginTop};
  width: 100%;
`

export const SSOButton = styled.button`
  width: 100%;
  background: transparent;
  color: #f2f4f7;
  height: 52px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
`

export const IncorrectUser = styled.label`
  font-family: 'Inter', sans-serif;
  color: tomato;
  font-size: 0.8rem;
  margin: 0.5em 0;
`
